import { ReactNode } from 'react';
import { helpers, Node } from '@contentful/rich-text-types';
import { fontGroups } from '@zoopla-eng/zds-components/themes';
import JumpLink from '../components/JumpLink';
import {
    textStyle,
    heading2Style,
    heading3Style,
    heading4Style
} from './renderHeadingOrJumpLink.styles.css';

const getText = (node: Node): string => {
    if (!helpers.isInline(node) && !helpers.isBlock(node)) return '';

    // Sometimes Editors can add line breaks formatted as headings, and
    // when this happens, the page errors because `helpers.isText()`
    // expects `node.content[0]` to have content/exist
    if (node.content.length === 0) return '';

    return helpers.isText(node.content[0]) ? node.content[0].value : '';
};

export const renderHeadingOrJumpLink = (node: Node, children: ReactNode) => {
    const type = node.nodeType;
    const text = getText(node);

    // If we have no text but children then it is likely the whole heading is a link, and we
    // don't want to create JumpLinks around real links. Ideally article headings should not
    // be links but we must support them for legacy articles.
    if (!text && children) {
        switch (type) {
            case 'heading-2':
                return (
                    <h2 className={`${heading2Style} ${fontGroups.plate}`}>
                        {children}
                    </h2>
                );
            case 'heading-3':
                return (
                    <h3 className={`${heading3Style} ${fontGroups.mug}`}>
                        {children}
                    </h3>
                );
            case 'heading-4':
                return (
                    <h4 className={`${heading4Style} ${fontGroups.whisk}`}>
                        {children}
                    </h4>
                );
            default:
                return (
                    <p className={`${textStyle} ${fontGroups.ladle}`}>
                        {children}
                    </p>
                );
        }
    }
    return (
        <JumpLink type={type} text={text}>
            {children}
        </JumpLink>
    );
};
